import { TypedObjNode } from "../../_Base";
import { Group } from "three";
import { DisplayNodeController } from "../../../utils/DisplayNodeController";
import { NodeContext } from "../../../../poly/NodeContext";
import { FlagsControllerD } from "../../../utils/FlagsController";
import { HierarchyController } from "../HierarchyController";
import { ChildrenDisplayController } from "../ChildrenDisplayController";
import { PolyNodeParamsConfig } from "../../../utils/poly/PolyNodeParamsConfig";
export function createPolyObjNode(nodeType, definition, polyNodeControllerClass) {
  const ParamsConfig = PolyNodeParamsConfig.ParamsConfig(definition);
  class BasePolyObjNode extends TypedObjNode {
    constructor() {
      super(...arguments);
      this.paramsConfig = ParamsConfig;
      this.hierarchyController = new HierarchyController(this);
      this.flags = new FlagsControllerD(this);
      this.childrenDisplayController = new ChildrenDisplayController(this);
      this.displayNodeController = new DisplayNodeController(this, this.childrenDisplayController.displayNodeControllerCallbacks());
      this._childrenControllerContext = NodeContext.SOP;
      this.polyNodeController = new polyNodeControllerClass(this, definition);
    }
    static type() {
      return nodeType;
    }
    createObject() {
      const group = new Group();
      group.matrixAutoUpdate = false;
      return group;
    }
    initializeNode() {
      this.hierarchyController.initializeNode();
      this.childrenDisplayController.initializeNode();
    }
    isDisplayNodeCooking() {
      if (this.flags.display.active()) {
        const display_node = this.displayNodeController.displayNode();
        return display_node ? display_node.isDirty() : false;
      } else {
        return false;
      }
    }
    createNode(node_class, options) {
      return super.createNode(node_class, options);
    }
    children() {
      return super.children();
    }
    nodesByType(type) {
      return super.nodesByType(type);
    }
    cook() {
      this.cookController.endCook();
    }
  }
  return BasePolyObjNode;
}
